import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { EddYesNo } from '@Pages/happyFlowPages/eddQuestions/consts';

export const MilitaryPreciousMetalsForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[24px] mt-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_MILITARY_EQUIPMENT}>
        {({ onChange, value }) => (
          <div className='flex flex-col gap-[16px]'>
            <Text.H9 className='text-text-main-primary'>
              {t('organic.militaryPreciousMetals.militaryTitle')}
            </Text.H9>
            <div className='flex flex-col gap-2'>
              <CustomRadioButton
                label={t('organic.militaryPreciousMetals.no')}
                value={EddYesNo.NO}
                inputId='military-no'
                onChange={onChange}
                checked={value === EddYesNo.NO}
                name={EddEmbeddedFields.EDD_MILITARY_EQUIPMENT}
              />
              <CustomRadioButton
                label={t('organic.militaryPreciousMetals.yes')}
                value={EddYesNo.YES}
                inputId='military-yes'
                onChange={onChange}
                checked={value === EddYesNo.YES}
                name={EddEmbeddedFields.EDD_MILITARY_EQUIPMENT}
              />
            </div>
          </div>
        )}
      </ControllerWrapper>

      <ControllerWrapper name={EddEmbeddedFields.EDD_PRECIOUS_METALS}>
        {({ onChange, value }) => (
          <div className='flex flex-col gap-[16px]'>
            <Text.H9 className='text-text-main-primary'>
              {t('organic.militaryPreciousMetals.preciousMetalsTitle')}
            </Text.H9>
            <div className='flex flex-col gap-2'>
              <CustomRadioButton
                label={t('organic.militaryPreciousMetals.no')}
                value={EddYesNo.NO}
                inputId='precious-metals-no'
                onChange={onChange}
                checked={value === EddYesNo.NO}
                name={EddEmbeddedFields.EDD_PRECIOUS_METALS}
              />
              <CustomRadioButton
                label={t('organic.militaryPreciousMetals.yes')}
                value={EddYesNo.YES}
                inputId='precious-metals-yes'
                onChange={onChange}
                checked={value === EddYesNo.YES}
                name={EddEmbeddedFields.EDD_PRECIOUS_METALS}
              />
            </div>
          </div>
        )}
      </ControllerWrapper>
    </div>
  );
};
